import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./LoBanner.css";
import htmlParser from "html-react-parser";

import ContactUsForm from "../ContactUS Form/ContactUsForm";
import Header from "../HeaderHome/index";

export default function Banner({
  lobannerData,
  dateTime,
  loanOfficer,
  loInformation,
}) {
  const [navbar, setNavbar] = useState(false);

  // Logo scroll function
  function scrollToSection1() {
    const sectionPosition = document.getElementById("contact-wrapper").offsetTop;
    window.scrollTo({
      top: sectionPosition,
      behavior: "smooth",
    });
  }

  const imgCDNURL = process.env.REACT_APP_CDN_URL;

  return (
    <>
      <div className="bannerbglo">
        <Container className="pt-3">
          <Row>
            <Col sm={12} md={12} lg={7} xl={7} className="dpaHeadingcol">
              {/* Event Name and Description */}
              <p className="dpaheadinglo">{lobannerData.eventName}</p>
            
              <p className="dpaheadinglo2">{lobannerData.bannerPara}</p>
              <p className="dpaheadinglo3">{lobannerData.bannerdes}</p>
            

              {/* What You'll Gain Section */}
              <div className="listoflist">
                <p className="meetgrit">{lobannerData.meetgrit}</p>
                <div className="meetgritdiv">
                <ul className="gain-points">
                  {lobannerData.whatYouWillGain.points.map((point, index) => (
                    <li key={index} className="gain-point">
                     {point.heading}
                      {/* <p>{point.description}</p> */}
                    </li>
                  ))}
                </ul>
                </div>
                <p className="call-to-action">{lobannerData.callToAction}</p>
              </div>

              {/* Event Date and Time */}
              <div className="maindflexte">
                <div className="d-flex">
                  <img
                    src={imgCDNURL + "calndersvg.svg"}
                    className="img-fluid calendericom"
                    alt="calendar"
                  />
                  <p className="dtttxt">{dateTime.date}</p>
                </div>
                <div className="d-flex secondddteflx">
                  <img
                    src={imgCDNURL + "timescg.svg"}
                    className="img-fluid calendericom"
                    alt="time"
                  />
                  <p className="dtttxt">{dateTime.time}</p>
                </div>
              </div>
            </Col>

            {/* Contact Us Form */}
            <Col sm={12} md={12} lg={5} xl={5} id="contactus">
              <ContactUsForm
                loanOfficer={loanOfficer}
                loInformation={loInformation}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
